// src/components/SwapTokens.js
import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  Box,
  Link,
  IconButton,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useWallet } from '@solana/wallet-adapter-react';
import { useBalance } from '../context/BalanceContext';

const SwapTokens = () => {
  const { publicKey } = useWallet();
  const { tokenBalance, fetchBalances, loading } = useBalance();
  const [error, setError] = useState(null);

  // 初回の残高取得時にエラーをセットする
  useEffect(() => {
    async function load() {
      try {
        await fetchBalances();
        setError(null);
      } catch (err) {
        setError(err.message || '読み込みエラーが発生しました。');
      }
    }
    if (publicKey) {
      load();
    }
  }, [publicKey, fetchBalances]);

  // ウォレット未接続時はその旨を表示
  if (!publicKey) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Paper
          sx={{
            p: 4,
            backgroundColor: '#002F2F',
            borderRadius: 2,
            maxWidth: 500,
            width: '100%',
          }}
          elevation={3}
        >
          <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', color: 'white' }}>
            Wallet is not connected
          </Typography>
          <Typography variant="body1" sx={{ color: 'white', mt: 2, textAlign: 'center' }}>
            You can buy EMCII on Phantom Wallet{' '}
            <Link
              href="https://phantom.com/tokens/solana/Gc3eJ7fhAaJR2YsxyNs9nCb4HydBiLryKGxghW613sYK"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'lightblue' }}
            >
              BUY NOW
            </Link>
          </Typography>
        </Paper>
      </Box>
    );
  }

  // 残高再取得用のハンドラー（エラーもハンドリング）
  const handleReload = async () => {
    try {
      await fetchBalances();
      setError(null);
    } catch (err) {
      setError(err.message || 'error occured');
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Paper
        sx={{
          p: 4,
          backgroundColor: '#002F2F',
          borderRadius: 2,
          maxWidth: 500,
          width: '100%',
        }}
        elevation={3}
      >
        {/* ヘッダー部分：タイトルを中央寄せ＆右側にリロードアイコン */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{ width: '100%', textAlign: 'center', color: 'white' }}
          >
            Your Balance
          </Typography>
          <IconButton
            onClick={handleReload}
            sx={{ position: 'absolute', right: 0, color: 'white' }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>

        {/* 残高表示部分 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Box sx={{ backgroundColor: '#004747', p: 2, borderRadius: 1 }}>
              <Typography variant="h6" sx={{ color: 'lightgreen' }}>
                {loading
                  ? 'Loading...'
                  : tokenBalance !== null
                  ? `${tokenBalance} EMCII`
                  : 'Fail to fetch your balance'}
              </Typography>
            </Box>
          </Grid>
        </Grid>

       

        <Typography variant="body1" sx={{ color: 'white', mt: 2, textAlign: 'center' }}>
          <Link
            href="https://phantom.com/tokens/solana/Gc3eJ7fhAaJR2YsxyNs9nCb4HydBiLryKGxghW613sYK"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'lightblue' }}
          >
            You can buy $EMCII via phantom wallet.
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
};

export default SwapTokens;



